export const GET_GETTING_STARTED_WITH = 'getGettingStartedWith';
export const SET_GETTING_STARTED_WITH = 'setGettingStartedWith';